/**
 * Shared Two-Tone paint-rule resolution for PDP and Touch-Up Finder.
 * Exact vehicle handles win first; overlapping rules then prefer the rule with
 * the narrowest configured YMM scope instead of unioning unrelated code lists.
 */
(function () {
	"use strict";

	function toHandle(value) {
		return String(value || "")
			.toLowerCase()
			.replace(/&/g, "and")
			.replace(/[^a-z0-9]+/g, "-")
			.replace(/^-+|-+$/g, "");
	}

	function uniqueHandles(values) {
		const handles = [];
		[].concat(values || []).forEach(function (value) {
			const handle = toHandle(value);
			if (handle && handles.indexOf(handle) === -1) handles.push(handle);
		});
		return handles;
	}

	function vehicleHandles(vehicle) {
		vehicle = vehicle || {};
		return uniqueHandles([
			vehicle.fitmentYmm,
			vehicle.year && vehicle.make && vehicle.model && vehicle.submodel
				? [vehicle.year, vehicle.make, vehicle.model, vehicle.submodel].join(" ")
				: "",
			vehicle.ymm || vehicle.YMM || vehicle.vehicle,
			vehicle.year && vehicle.make && vehicle.model
				? [vehicle.year, vehicle.make, vehicle.model].join(" ")
				: "",
		]);
	}

	function selectRule(rules, vehicleOrHandles) {
		const handles = Array.isArray(vehicleOrHandles)
			? uniqueHandles(vehicleOrHandles)
			: vehicleHandles(vehicleOrHandles);
		let best = null;

		[].concat(rules || []).forEach(function (rule, ruleIndex) {
			if (!rule || typeof rule !== "object") return;
			const ymms = uniqueHandles(rule.ymms);
			let handleIndex = -1;
			let matchedHandle = "";
			handles.some(function (handle, index) {
				if (ymms.indexOf(handle) === -1) return false;
				handleIndex = index;
				matchedHandle = handle;
				return true;
			});
			if (handleIndex === -1) return;

			const configuredScope = Number(rule.scopeSize);
			const scopeSize = configuredScope > 0 ? configuredScope : ymms.length;
			if (
				!best ||
				handleIndex < best.handleIndex ||
				(handleIndex === best.handleIndex && scopeSize < best.scopeSize)
			) {
				best = {
					rule: rule,
					ruleIndex: ruleIndex,
					handleIndex: handleIndex,
					matchedHandle: matchedHandle,
					scopeSize: scopeSize,
				};
			}
		});

		if (!best) return null;
		return {
			rule: best.rule,
			ruleIndex: best.ruleIndex,
			matchedHandle: best.matchedHandle,
			scopeSize: best.scopeSize,
			codes: Array.isArray(best.rule.codes) ? best.rule.codes.slice() : [],
		};
	}

	window.PartifyTwoToneRuleResolver = {
		toHandle: toHandle,
		vehicleHandles: vehicleHandles,
		selectRule: selectRule,
	};
})();
